import { useEffect, useRef, useState } from '@wordpress/element';

const ModalOverlay = ({ children, onClose }) => {
  const modalRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragStartRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    const handleMouseMove = (event) => {
      if (isDragging) {
        const deltaX = event.clientX - dragStartRef.current.x;
        const deltaY = event.clientY - dragStartRef.current.y;
        
        setPosition(prev => ({
          x: prev.x + deltaX,
          y: prev.y + deltaY
        }));
        
        dragStartRef.current = {
          x: event.clientX,
          y: event.clientY
        };
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    // REMOVED: Click outside handler
    document.addEventListener('keydown', handleEscapeKey);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, isDragging]);

  const handleHeaderMouseDown = (event) => {
    if (event.target.closest('.hvnly--builder---api_property__builder___header_action_link')) {
      return;
    }
    
    setIsDragging(true);
    dragStartRef.current = {
      x: event.clientX,
      y: event.clientY
    };
    
    event.preventDefault();
  };

  return (
    <div className="hvnly--builder---api_property__builder___widget_insert_modal_container active">
      <div 
        ref={modalRef}
        className="hvnly--builder---api_property__builder___option_card"
        style={{
          transform: `translate(calc(-50% + ${position.x}px), calc(-50% + ${position.y}px))`,
          cursor: isDragging ? 'grabbing' : 'default'
        }}
      >
        <div 
          className="hvnly--builder---api_property__builder___option_card_header"
          onMouseDown={handleHeaderMouseDown}
          style={{ cursor: 'move' }}
        >
          {React.Children.toArray(children)[0]}
        </div>
        <div className="hvnly--builder---api_property__builder___option_card_body">
          {React.Children.toArray(children)[1]}
        </div>
      </div>
    </div>
  );
};

export default ModalOverlay;